/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS AUTOMATICALLY GENERATED FROM API ROUTES      ##
 * ---------------------------------------------------------------
 */

export const SCHOOLY_API_V1_PATHS = {
  APPLICATION_AVAILABLE_ADULTS_LIST: '/application/available-adults' as const,
  APPLICATION_CREATE_CREATE: '/application/create/{school_id}' as const,
  APPLICATION_CREATE_PUBLIC_CREATE: '/application/create/{school_id}/public' as const,
  APPLICATION_CREATE_STAFF_CREATE: '/application/create/{school_id}/staff' as const,
  APPLICATION_FOR_CHILDREN_LIST: '/application/for-children' as const,
  APPLICATION_LIST_LIST: '/application/list' as const,
  APPLICATION_PARENT_LIST_LIST: '/application/parent/list' as const,
  APPLICATION_DETAIL: '/application/{application_id}' as const,
  APPLICATION_PARTIAL_UPDATE: '/application/{application_id}' as const,
  APPLICATION_CONVERT_PARTIAL_UPDATE: '/application/{application_id}/convert' as const,
  APPLICATION_NOTES_PARTIAL_UPDATE: '/application/{application_id}/notes' as const,
  APPLICATION_REJECT_PARTIAL_UPDATE: '/application/{application_id}/reject' as const,
  ASSESSMENT_ENTRIES_FOR_METHOD_FOR_RELATION_CREATE: '/assessment/entries/for-method/{method_id}/for-relation/{recipient_relation_id}/' as const,
  ASSESSMENT_FOR_GROUP_DETAIL: '/assessment/for-group/{group_id}' as const,
  ASSESSMENT_FOR_GROUP_ENTRIES_LIST: '/assessment/for-group/{group_id}/entries' as const,
  ASSESSMENT_FOR_PROFILE_DETAIL: '/assessment/for-profile/{profile_id}' as const,
  ASSESSMENT_FOR_PROFILE_ENTRIES_LIST: '/assessment/for-profile/{profile_id}/entries' as const,
  ASSESSMENT_FOR_PROFILE_OVERVIEW_LIST: '/assessment/for-profile/{profile_id}/overview' as const,
  ASSESSMENT_FOR_RELATION_ENTRIES_LIST: '/assessment/for-relation/{relation_id}/entries' as const,
  ASSESSMENT_FOR_SCHOOL_LIST: '/assessment/for-school/{school_id}/' as const,
  ASSESSMENT_FOR_SCHOOL_CREATE: '/assessment/for-school/{school_id}/' as const,
  ASSESSMENT_FOR_SCHOOL_AGGREGATE_LIST: '/assessment/for-school/{school_id}/aggregate' as const,
  ASSESSMENT_DETAIL: '/assessment/{assessment_id}' as const,
  ASSESSMENT_DELETE: '/assessment/{assessment_id}/' as const,
  ASSESSMENT_PARTIAL_UPDATE: '/assessment/{assessment_id}/' as const,
  ASSESSMENT_ACTION_CREATE: '/assessment/{assessment_id}/action' as const,
  ASSESSMENT_GROUPS_LIST: '/assessment/{assessment_id}/groups' as const,
  ATTENDANCE_ABSENCE_CREATE: '/attendance/absence' as const,
  CODES_FOR_ATTENDANCE_PARTIAL_UPDATE: '/attendance/codes/for-attendance/{attendance_code_id}/' as const,
  ATTENDANCE_CODES_FOR_SCHOOL_CREATE: '/attendance/codes/for-school/{school_id}/' as const,
  ATTENDANCE_CODES_FOR_SCHOOL_LIST: '/attendance/codes/for-school/{school_id}/' as const,
  ATTENDANCE_CODES_ORDER_FOR_SCHOOL_PARTIAL_UPDATE: '/attendance/codes/order/for-school/{school_id}/' as const,
  ATTENDANCE_CODES_DELETE: '/attendance/codes/{code_id}/' as const,
  ATTENDANCE_ENTRIES_FOR_REGISTER_FOR_RELATION_CREATE: '/attendance/entries/for-register/{register_id}/for-relation/{relation_id}' as const,
  ATTENDANCE_FOR_GROUP_ENTRIES_CREATE: '/attendance/for-group/{group_id}/entries' as const,
  ATTENDANCE_FOR_GROUP_ENTRIES_FOR_DATE_LIST: '/attendance/for-group/{group_id}/entries/for-date' as const,
  ATTENDANCE_FOR_GROUP_ENTRIES_FOR_PERIOD_LIST: '/attendance/for-group/{group_id}/entries/for-period' as const,
  ATTENDANCE_FOR_PROFILE_ENTRIES_DETAIL: '/attendance/for-profile/{profile_id}/entries/{attendance_code_id}' as const,
  ATTENDANCE_FOR_PROFILE_OVERVIEW_LIST: '/attendance/for-profile/{profile_id}/overview' as const,
  ATTENDANCE_FOR_RELATION_ENTRIES_LIST: '/attendance/for-relation/{relation_id}/entries' as const,
  ATTENDANCE_REGISTER_FOR_SCHOOL_CREATE: '/attendance/register-for-school/{school_id}/' as const,
  ATTENDANCE_REGISTER_LIST: '/attendance/register/{register_id}/' as const,
  ATTENDANCE_REGISTER_DELETE: '/attendance/register/{register_id}/' as const,
  ATTENDANCE_REGISTER_PARTIAL_UPDATE: '/attendance/register/{register_id}/' as const,
  ATTENDANCE_REGISTERS_FOR_SCHOOL_LIST: '/attendance/registers-for-school/{school_id}/' as const,
  ATTENDANCE_REGISTERS_FOR_SCHOOL_STATISTICS_LIST: '/attendance/registers-for-school/{school_id}/statistics' as const,
  BILLING_COUNT_LIST: '/billing/count' as const,
  BILLING_FREQUENCIES_LIST: '/billing/frequencies' as const,
  BILLING_FREQUENCIES_PARTIAL_UPDATE: '/billing/frequencies/{frequency_id}' as const,
  BILLING_INVOICE_AGGREGATED_LIST: '/billing/invoice/aggregated' as const,
  BILLING_LEGAL_ENTITIES_LIST: '/billing/legal-entities' as const,
  BILLING_LEGAL_ENTITIES_CREATE: '/billing/legal-entities' as const,
  BILLING_LEGAL_ENTITIES_VALIDATE_LEGAL_ENTITY_CREATE: '/billing/legal-entities/validate-legal-entity' as const,
  BILLING_LEGAL_ENTITIES_DETAIL: '/billing/legal-entities/{legal_entity_id}' as const,
  BILLING_LEGAL_ENTITIES_PARTIAL_UPDATE: '/billing/legal-entities/{legal_entity_id}' as const,
  BILLING_LEGAL_ENTITIES_DELETE: '/billing/legal-entities/{legal_entity_id}' as const,
  CONDUCT_COMMENT_FOR_ENTRY_CREATE: '/conduct/comment/for-entry/{entry_id}/' as const,
  CONDUCT_COMMENT_PARTIAL_UPDATE: '/conduct/comment/{conduct_comment_id}/' as const,
  CONDUCT_ENTRIES_FOR_SCHOOL_LIST: '/conduct/entries/for-school/{school_id}/' as const,
  CONDUCT_ENTRIES_FOR_SCHOOL_AGGREGATE_LIST: '/conduct/entries/for-school/{school_id}/aggregate' as const,
  CONDUCT_ENTRIES_FOR_TYPE_CREATE: '/conduct/entries/for-type/{conduct_type_id}/' as const,
  CONDUCT_ENTRIES_PROFILES_LIST: '/conduct/entries/profiles/{profile_id}/' as const,
  CONDUCT_ENTRIES_PARTIAL_UPDATE: '/conduct/entries/{conduct_entry_id}/' as const,
  CONDUCT_ENTRIES_DELETE: '/conduct/entries/{conduct_entry_id}/' as const,
  HANDLE_CONDUCT_TYPES_CREATE: '/conduct/handle-conduct-types/{school_id}' as const,
  CONDUCT_STATS_FOR_SCHOOL_LIST: '/conduct/stats/for-school/{school_id}/' as const,
  CONDUCT_TYPE_DETAIL: '/conduct/type/{conduct_type_id}' as const,
  CONDUCT_TYPE_DELETE: '/conduct/type/{conduct_type_id}' as const,
  CONDUCT_TYPE_PARTIAL_UPDATE: '/conduct/type/{conduct_type_id}' as const,
  CONDUCT_TYPES_FOR_SCHOOL_CREATE: '/conduct/types/for-school/{school_id}/' as const,
  CONDUCT_TYPES_FOR_SCHOOL_LIST: '/conduct/types/for-school/{school_id}/' as const,
  CONSENT_FORM_CREATE: '/consent-form' as const,
  CONSENT_FORM_FOR_RELATION_DETAIL: '/consent-form/for-relation/{relation_id}' as const,
  CONSENT_FORM_FOR_RELATION_HISTORY_LIST: '/consent-form/for-relation/{relation_id}/history' as const,
  CONSENT_FORM_PARENT_HISTORY_LIST: '/consent-form/parent/history' as const,
  CONSENT_FORM_PARENT_DETAIL: '/consent-form/parent/{consent_form_id}' as const,
  CONSENT_FORM_PARENT_HISTORY_LIST2: '/consent-form/parent/{consent_form_id}/history' as const,
  CONSENT_FORM_DELETE: '/consent-form/{consent_form_id}' as const,
  CONSENT_FORM_PARTIAL_UPDATE: '/consent-form/{consent_form_id}' as const,
  CONSENT_FORM_DETAIL: '/consent-form/{consent_form_id}' as const,
  CONSENT_FORM_ITEMS_LIST: '/consent-form/{consent_form_id}/items' as const,
  CONSENT_FORM_SIGN_CREATE: '/consent-form/{consent_form_id}/sign' as const,
  CUSTOM_FIELD_FOR_SCHOOL_DETAIL: '/custom_field/for-school/{school_id}' as const,
  CUSTOM_FIELD_FOR_SCHOOL_CREATE: '/custom_field/for-school/{school_id}/' as const,
  CUSTOM_FIELD_FOR_SCHOOL_PUBLIC_LIST: '/custom_field/for-school/{school_id}/public' as const,
  CUSTOM_FIELD_VALUE_FOR_RELATION_DETAIL: '/custom_field/value/for-relation/{relation_id}' as const,
  CUSTOM_FIELD_VALUE_FOR_RELATION_CREATE: '/custom_field/value/for-relation/{relation_id}' as const,
  CUSTOM_FIELD_PARTIAL_UPDATE: '/custom_field/{id}' as const,
  CUSTOM_FIELD_DELETE: '/custom_field/{id}' as const,
  DIRECTORY_FILTERS_LIST: '/directory/filters' as const,
  DIRECTORY_LOCATION_LIST: '/directory/location' as const,
  DIRECTORY_SCHOOL_LIST: '/directory/school' as const,
  DIRECTORY_SCHOOL_DETAIL: '/directory/school/{school_id}' as const,
  DIRECTORY_SCHOOL_ENQUIRE_CREATE: '/directory/school/{school_id}/enquire' as const,
  DIRECTORY_SCHOOL_MY_SCHOOL_CREATE: '/directory/school/{school_id}/my-school' as const,
  EVENTS_FOR_PARENT_LIST: '/events/for-parent' as const,
  EVENTS_FOR_PARENT_DETAIL: '/events/for-parent/{event_id}' as const,
  EVENTS_FOR_SCHOOL_CREATE: '/events/for-school/{school_id}/' as const,
  EVENTS_FOR_SCHOOL_LIST: '/events/for-school/{school_id}/' as const,
  EVENTS_FOR_SCHOOL_ACTION_CREATE: '/events/for-school/{school_id}/action' as const,
  EVENTS_FOR_SCHOOL_AGGREGATE_LIST: '/events/for-school/{school_id}/aggregate' as const,
  EVENTS_SIGN_UPS_FOR_PARENT_LIST: '/events/sign-ups/for-parent' as const,
  EVENTS_SIGN_UPS_FOR_PARENT_CREATE: '/events/sign-ups/for-parent' as const,
  EVENTS_SIGN_UPS_FOR_PARENT_DETAIL: '/events/sign-ups/for-parent/{sign_up_id}' as const,
  EVENTS_SIGN_UPS_FOR_PARENT_PARTIAL_UPDATE: '/events/sign-ups/for-parent/{sign_up_id}' as const,
  EVENTS_SIGN_UPS_FOR_PARENT_CANCEL_DELETE: '/events/sign-ups/for-parent/{sign_up_id}/cancel' as const,
  EVENTS_SIGN_UPS_FOR_SCHOOL_DETAIL: '/events/sign-ups/for-school/{school_id}' as const,
  EVENTS_SIGN_UPS_FOR_SCHOOL_CREATE: '/events/sign-ups/for-school/{school_id}' as const,
  EVENTS_SIGN_UPS_FOR_SCHOOL_ACTION_CREATE: '/events/sign-ups/for-school/{school_id}/action' as const,
  EVENTS_SIGN_UPS_PARTIAL_UPDATE: '/events/sign-ups/{sign_up_id}' as const,
  EVENTS_SIGN_UPS_DELETE: '/events/sign-ups/{sign_up_id}' as const,
  EVENTS_SIGN_UPS_DETAIL: '/events/sign-ups/{sign_up_id}' as const,
  EVENTS_SIGN_UPS_RESPONDENTS_LIST: '/events/sign-ups/{sign_up_id}/respondents' as const,
  EVENTS_PARTIAL_UPDATE: '/events/{event_id}/' as const,
  EVENTS_DELETE: '/events/{event_id}/' as const,
  EVENTS_LIST: '/events/{event_id}/' as const,
  EXPORT_ASSESSMENT_FOR_GROUP_DETAIL: '/export/assessment/for-group/{group_id}' as const,
  EXPORT_ASSESSMENT_FOR_RELATION_DETAIL: '/export/assessment/for-relation/{relation_id}' as const,
  EXPORT_ASSESSMENT_SINGLE_DETAIL: '/export/assessment/single/{assessment_id}' as const,
  EXPORT_ATTENDANCE_FOR_GROUP_DETAIL: '/export/attendance/for-group/{group_id}' as const,
  EXPORT_ATTENDANCE_REGISTER_DETAIL: '/export/attendance/register/{register_id}' as const,
  EXPORT_ATTENDANCE_DETAIL: '/export/attendance/{school_id}' as const,
  EXPORT_CONDUCT_FOR_GROUP_DETAIL: '/export/conduct/for-group/{group_id}' as const,
  EXPORT_CONDUCT_FOR_RELATION_DETAIL: '/export/conduct/for-relation/{relation_id}' as const,
  EXPORT_CONDUCT_DETAIL: '/export/conduct/{school_id}' as const,
  EXPORT_CONSENT_FORM_DETAIL: '/export/consent-form/{consent_form_id}' as const,
  EXPORT_REPORTS_FOR_PROFILE_DETAIL: '/export/reports/for-profile/{profile_id}' as const,
  EXPORT_SIGN_UPS_RESPONDENTS_DETAIL: '/export/sign-ups/respondents/{sign_up_id}' as const,
  EXPORT_STUDENTS_DETAIL: '/export/students/{group_id}' as const,
  EXPORT_TERMS_AND_CONDITIONS_DETAIL: '/export/terms-and-conditions/{id}' as const,
  GROUPS_LIST: '/groups' as const,
  GROUPS_CREATE: '/groups' as const,
  GROUPS_AGGREGATE_LIST: '/groups/aggregate' as const,
  GROUPS_AVAILABLE_CRITERIA_LIST: '/groups/available-criteria' as const,
  GROUPS_AVAILABLE_CRITERIA_BY_COUNT_LIST: '/groups/available-criteria-by-count' as const,
  GROUPS_AVAILABLE_FOR_RELATION_DETAIL: '/groups/available-for-relation/{relation_id}' as const,
  GROUPS_CHECK_GROUP_NAME_LIST: '/groups/check-group-name' as const,
  GROUPS_CHECK_UNIQUENESS_LIST: '/groups/check-uniqueness' as const,
  GROUPS_CREATE_SUBJECTS_CREATE: '/groups/create-subjects' as const,
  GROUPS_EXPORT_LIST: '/groups/export' as const,
  GROUPS_FOR_PROFILE_DETAIL: '/groups/for-profile/{profile_id}' as const,
  GROUPS_FOR_RELATION_PARTIAL_UPDATE: '/groups/for-relation/{relation_id}' as const,
  GROUPS_FOR_RELATION_DETAIL: '/groups/for-relation/{relation_id}' as const,
  GROUPS_FOR_USER_DETAIL: '/groups/for-user/{id}' as const,
  GROUPS_HANDLE_SUBJECTS_CREATE: '/groups/handle-subjects/{school_id}' as const,
  GROUPS_MEMBERS_FOR_GROUP_DETAIL: '/groups/members-for-group/{id}' as const,
  GROUPS_MEMBERSHIPS_DATES_PARTIAL_UPDATE: '/groups/memberships-dates/{group_id}' as const,
  GROUPS_SUBJECTS_LIST: '/groups/subjects' as const,
  GROUPS_SUBJECTS_ATTENDANCE_PARTIAL_UPDATE: '/groups/subjects/attendance/{school_id}' as const,
  GROUPS_DETAIL: '/groups/{id}' as const,
  GROUPS_PARTIAL_UPDATE: '/groups/{id}' as const,
  GROUPS_DELETE: '/groups/{id}' as const,
  INTEGRATION_WEBHOOK_HANDLE_UNKNOWN_CREATE: '/integration/webhook-handle-unknown' as const,
  INTEGRATION_XERO_RESET_LIST: '/integration/xero-reset' as const,
  INTEGRATION_XERO_TEST_SUPER_SECRET_LIST: '/integration/xero-test-super-secret' as const,
  INTEGRATION_XERO_CHECK_LIST: '/integration/xero/check' as const,
  INTEGRATION_XERO_REFRESH_CREATE: '/integration/xero/refresh' as const,
  INTEGRATION_XERO_SETUP_CREATE: '/integration/xero/setup' as const,
  INVOICES_ACCOUNTS_DETAIL: '/invoices/accounts/{school_id}' as const,
  INVOICES_ACTION_CREATE: '/invoices/action' as const,
  INVOICES_COMPANIES_FOR_SCHOOL_CREATE: '/invoices/companies/for-school/{school_id}' as const,
  INVOICES_COMPANIES_FOR_SCHOOL_DETAIL: '/invoices/companies/for-school/{school_id}' as const,
  INVOICES_COMPANIES_FOR_SCHOOL_VALIDATE_COMPANY_CREATE: '/invoices/companies/for-school/{school_id}/validate-company' as const,
  INVOICES_COMPANIES_PARTIAL_UPDATE: '/invoices/companies/{company_id}' as const,
  INVOICES_COMPANIES_DELETE: '/invoices/companies/{company_id}' as const,
  INVOICES_COMPANIES_DETAIL: '/invoices/companies/{company_id}' as const,
  INVOICES_FREQUENCIES_DETAIL: '/invoices/frequencies/{school_id}' as const,
  INVOICES_INVOICE_FOR_PARENT_LIST: '/invoices/invoice/for-parent' as const,
  INVOICES_INVOICE_FOR_PARENT_STATISTICS_LIST: '/invoices/invoice/for-parent/statistics' as const,
  INVOICES_INVOICE_FOR_PARENT_DETAIL: '/invoices/invoice/for-parent/{invoice_id}' as const,
  INVOICES_INVOICE_FOR_SCHOOL_LIST: '/invoices/invoice/for-school' as const,
  INVOICES_INVOICE_FOR_SCHOOL_STATISTICS_LIST: '/invoices/invoice/for-school/statistics' as const,
  INVOICES_PRODUCTS_ASSIGNMENT_PREVIEW_CREATE: '/invoices/products/assignment-preview' as const,
  INVOICES_PRODUCTS_FOR_PARENT_DETAIL: '/invoices/products/for-parent/{school_relation_id}' as const,
  INVOICES_PRODUCTS_FOR_RELATION_DETAIL: '/invoices/products/for-relation/{school_relation_id}' as const,
  INVOICES_PRODUCTS_FOR_RELATION_PARTIAL_UPDATE: '/invoices/products/for-relation/{school_relation_id}' as const,
  INVOICES_PRODUCTS_FOR_SCHOOL_DETAIL: '/invoices/products/for-school/{school_id}' as const,
  INVOICES_PRODUCTS_FOR_SCHOOL_CREATE: '/invoices/products/for-school/{school_id}' as const,
  INVOICES_PRODUCTS_FOR_SCHOOL_VALIDATE_NAME_CREATE: '/invoices/products/for-school/{school_id}/validate-name' as const,
  INVOICES_PRODUCTS_DETAIL: '/invoices/products/{product_id}' as const,
  INVOICES_PRODUCTS_PARTIAL_UPDATE: '/invoices/products/{product_id}' as const,
  INVOICES_PRODUCTS_DELETE: '/invoices/products/{product_id}' as const,
  SINGLE_INVOICES_CREATE: '/invoices/single-invoices' as const,
  INVOICES_STUDENTS_FOR_COMPANY_DETAIL: '/invoices/students/for-company/{company_id}' as const,
  INVOICES_STUDENTS_FOR_PARENT_DETAIL: '/invoices/students/for-parent/{school_relation_id}' as const,
  INVOICES_STUDENTS_FOR_SCHOOL_DETAIL: '/invoices/students/for-school/{school_id}' as const,
  INVOICES_DETAIL: '/invoices/{invoice_id}' as const,
  INVOICES_PARTIAL_UPDATE: '/invoices/{invoice_id}' as const,
  MESSAGES_ARCHIVE_PARTIAL_UPDATE: '/messages/archive/{message_id}/' as const,
  MESSAGES_CREATE_CREATE: '/messages/create/' as const,
  MESSAGES_FILE_LIST: '/messages/file/{id}/' as const,
  MESSAGES_FOR_GROUP_LIST: '/messages/for-group/{id}/' as const,
  MESSAGES_FOR_PROFILE_SINGLE_MESSAGE_DETAIL: '/messages/for-profile/single-message/{message_id}' as const,
  MESSAGES_FOR_RELATION_LIST: '/messages/for-relation/{id}/' as const,
  MESSAGES_FOR_SCHOOL_LIST: '/messages/for-school/{school_id}/' as const,
  MESSAGES_FOR_SCHOOL_AGGREGATE_LIST: '/messages/for-school/{school_id}/aggregate' as const,
  MESSAGES_FOR_SCHOOL_COUNTS_LIST: '/messages/for-school/{school_id}/counts' as const,
  MESSAGES_INTERNAL_DETAIL: '/messages/internal/{message_id}' as const,
  MESSAGES_INTERNAL_PARTICIPANTS_LIST: '/messages/internal/{message_id}/participants' as const,
  MESSAGES_LABEL_LIST: '/messages/label/' as const,
  MESSAGES_LABEL_PARTIAL_UPDATE: '/messages/label/{message_id}/' as const,
  MESSAGES_PARENT_LIST: '/messages/parent/' as const,
  MESSAGES_USER_LIST: '/messages/user/' as const,
  MESSAGES_PARTIAL_UPDATE: '/messages/{id}/' as const,
  MESSAGES_DELETE: '/messages/{id}/' as const,
  MESSAGES_ACTION_CREATE: '/messages/{id}/action' as const,
  MESSAGES_READ_PARTIAL_UPDATE: '/messages/{id}/read' as const,
  MESSAGES_LIST: '/messages/{message_id}/' as const,
  PROFILE_ADD_FAMILY_CREATE: '/profile/add-family' as const,
  PROFILE_ADULT_INVITES_CREATE: '/profile/adult-invites' as const,
  PROFILE_ADULT_INVITES_DELETE: '/profile/adult-invites/{adult_id}' as const,
  PROFILE_ADULT_INVITES_RESEND_CREATE: '/profile/adult-invites/{adult_id}/resend' as const,
  PROFILE_ADULTS_DELETE: '/profile/adults/{adult_id}' as const,
  PROFILE_ADULTS_PARTIAL_UPDATE: '/profile/adults/{adult_id}' as const,
  PROFILE_ADULTS_UPDATE: '/profile/adults/{adult_id}' as const,
  PROFILE_ADULTS_CHILD_DELETE: '/profile/adults/{adult_id}/child/{child_id}' as const,
  PROFILE_ADULTS_CHILDREN_LIST: '/profile/adults/{adult_id}/children' as const,
  PROFILE_APPLICATION_SETTINGS_FOR_PARENT_CREATE: '/profile/application-settings/for-parent' as const,
  PROFILE_APPLICATION_SETTINGS_FOR_PARENT_PARTIAL_UPDATE: '/profile/application-settings/for-parent' as const,
  PROFILE_CHILDREN_CREATE: '/profile/children' as const,
  PROFILE_CHILDREN_DETAIL: '/profile/children/{child_id}' as const,
  PROFILE_CHILDREN_MEDICAL_NEEDS_CREATE: '/profile/children/{child_id}/medical-needs' as const,
  PROFILE_CHILDREN_MEDICAL_NEEDS_PARTIAL_UPDATE: '/profile/children/{child_id}/medical-needs/{medical_needs_id}' as const,
  PROFILE_CONNECT_WHATSAPP_FOR_PARENT_CREATE: '/profile/connect-whatsapp/for-parent' as const,
  PROFILE_COUNTERS_DETAIL: '/profile/counters/{profile_id}' as const,
  DEMO_PROFILE_LIST: '/profile/demo-profile/' as const,
  PROFILE_EDIT_FAMILY_PARTIAL_UPDATE: '/profile/edit-family' as const,
  PROFILE_FEEDBACK_CREATE: '/profile/feedback/' as const,
  PROFILE_LIST_LIST: '/profile/list/' as const,
  PROFILE_NOTIFICATIONS_SETTINGS_FOR_PARENT_PARTIAL_UPDATE: '/profile/notifications-settings/for-parent' as const,
  PROFILE_REQUEST_WHATSAPP_CODE_FOR_PARENT_CREATE: '/profile/request-whatsapp-code/for-parent' as const,
  REGISTRATION_ADMISSIONS_AGGREGATE_LIST: '/registration/admissions/aggregate' as const,
  REGISTRATION_EMPLOYMENTS_LIST: '/registration/employments' as const,
  REGISTRATION_EMPLOYMENTS_CREATE: '/registration/employments' as const,
  REGISTRATION_EMPLOYMENTS_PARTIAL_UPDATE: '/registration/employments/{employment_id}' as const,
  REGISTRATION_EMPLOYMENTS_DELETE: '/registration/employments/{employment_id}' as const,
  REGISTRATION_ENROLLMENTS_LIST: '/registration/enrollments' as const,
  REGISTRATION_ENROLLMENTS_CREATE: '/registration/enrollments' as const,
  REGISTRATION_ENROLLMENTS_RE_ENROLLMENT_PARTIAL_UPDATE: '/registration/enrollments/re-enrollment/{re_enrollment_id}' as const,
  REGISTRATION_ENROLLMENTS_PARTIAL_UPDATE: '/registration/enrollments/{enrollment_id}' as const,
  REGISTRATION_ENROLLMENTS_DELETE: '/registration/enrollments/{enrollment_id}' as const,
  REGISTRATION_REENROLMENTS_CREATE: '/registration/reenrolments' as const,
  REGISTRATION_REENROLMENTS_ASSIGNMENT_PREVIEW_CREATE: '/registration/reenrolments/assignment-preview' as const,
  REGISTRATION_STUDENTS_ROLLOVER_CREATE: '/registration/students/rollover' as const,
  REGISTRATION_STUDENTS_ROLLOVER_AGGREGATE_CREATE: '/registration/students/rollover/aggregate' as const,
  REGISTRATION_STUDENTS_ROLLOVER_INCONSISTENCIES_CREATE: '/registration/students/rollover/inconsistencies' as const,
  REGISTRATION_STUDENTS_ROLLOVER_INCONSISTENCIES_LIST_CREATE: '/registration/students/rollover/inconsistencies/list' as const,
  REPORTS_FOR_PROFILE_LIST: '/reports/for-profile/{profile_id}/' as const,
  REPORTS_FOR_PROFILE_PAGINATED_LIST: '/reports/for-profile/{profile_id}/paginated' as const,
  REPORTS_FOR_RELATION_DETAIL: '/reports/for-relation/{relation_id}' as const,
  REPORTS_FOR_SCHOOL_LIST: '/reports/for-school/{school_id}/' as const,
  REPORTS_FOR_SCHOOL_CREATE: '/reports/for-school/{school_id}/' as const,
  REPORTS_FOR_SCHOOL_AREAS_OF_LEARNING_LIST: '/reports/for-school/{school_id}/areas-of-learning/' as const,
  REPORTS_FOR_SCHOOL_POSSIBLE_ASSESSMENTS_CREATE: '/reports/for-school/{school_id}/possible-assessments/' as const,
  REPORTS_DETAIL: '/reports/{report_id}' as const,
  REPORTS_DELETE: '/reports/{report_id}/' as const,
  REPORTS_PARTIAL_UPDATE: '/reports/{report_id}/' as const,
  REPORTS_ACTION_CREATE: '/reports/{report_id}/action' as const,
  REPORTS_RECIPIENTS_LIST: '/reports/{report_id}/recipients' as const,
  SCHOOL_DETAILS_SCHOOL_CANCEL_LEAVING_SCHOOL_CREATE: '/school_details/school/{school_id}/cancel-leaving-school' as const,
  SCHOOL_DETAILS_SCHOOL_LEAVE_SCHOOL_CREATE: '/school_details/school/{school_id}/leave-school/{child_id}/' as const,
  SCHOOL_DETAILS_SCHOOL_PROPERTIES_LIST: '/school_details/school/{school_id}/properties' as const,
  SCHOOL_DETAILS_SCHOOL_SETTINGS_LIST: '/school_details/school/{school_id}/settings' as const,
  SCHOOL_DETAILS_SCHOOL_SETTINGS_LEAVING_SCHOOL_LIST: '/school_details/school/{school_id}/settings/leaving-school' as const,
  SCHOOL_DETAILS_SCHOOL_SETTINGS_LEAVING_SCHOOL_CREATE: '/school_details/school/{school_id}/settings/leaving-school' as const,
  SCHOOL_DETAILS_SCHOOL_SETTINGS_LEAVING_SCHOOL_REASONS_LIST: '/school_details/school/{school_id}/settings/leaving-school/reasons/' as const,
  SCHOOL_DETAILS_SCHOOL_SETTINGS_LEAVING_SCHOOL_REASONS_CREATE: '/school_details/school/{school_id}/settings/leaving-school/reasons/' as const,
  SCHOOL_DETAILS_SCHOOL_SETTINGS_RE_ENROLLMENT_LIST: '/school_details/school/{school_id}/settings/re-enrollment' as const,
  SCHOOL_DETAILS_SCHOOL_SETTINGS_RE_ENROLLMENT_PARTIAL_UPDATE: '/school_details/school/{school_id}/settings/re-enrollment' as const,
  SCHOOL_DETAILS_SCHOOL_SETTINGS_TERMS_AND_CONDITIONS_PARTIAL_UPDATE: '/school_details/school/{school_id}/settings/terms-and-conditions' as const,
  SCHOOL_DETAILS_SCHOOL_YEARS_LIST: '/school_details/school/{school_id}/years' as const,
  SCHOOL_DETAILS_SCHOOLS_FOR_PARENT_LIST: '/school_details/schools/for-parent' as const,
  SCHOOL_DETAILS_SCHOOLS_FOR_PARENT_DETAIL: '/school_details/schools/for-parent/{school_id}' as const,
  SCHOOL_DETAILS_SCHOOLS_FOR_PARENT_ENROLMENT_HISTORY_DETAIL: '/school_details/schools/for-parent/{school_id}/enrolment-history/{child_id}' as const,
  SCHOOL_DETAILS_AGE_GROUPS_PARTIAL_UPDATE: '/school_details/{id}/age_groups' as const,
  SCHOOL_DETAILS_PLAN_DETAIL: '/school_details/{id}/plan/{year_id}' as const,
  SCHOOL_CHANGE_DEFAULT_VALUES_FOR_PROPERTIES_CREATE: '/school/change-default-values-for-properties/{school_id}' as const,
  CHANGE_LAST_SCHOOL_CREATE: '/school/change-last-school' as const,
  CREATE_SCHOOL_CREATE: '/school/create-school' as const,
  CREATE_SCHOOL_WITH_PROPS_CREATE: '/school/create-school-with-props' as const,
  EDIT_SCHOOL_PARTIAL_UPDATE: '/school/edit-school' as const,
  SCHOOL_GET_CATEGORIES_LIST: '/school/get-categories' as const,
  SCHOOL_HANDLE_DEPARTMENTS_CREATE: '/school/handle-departments/{school_id}' as const,
  SCHOOL_HANDLE_HOUSES_CREATE: '/school/handle-houses/{school_id}' as const,
  HANDLE_SCHOOL_YEARS_CREATE: '/school/handle-school-years/{school_id}' as const,
  SCHOOL_HANDLE_STATUSES_CREATE: '/school/handle-statuses/{school_id}' as const,
  PARENT_SCHOOL_RELATION_PARTIAL_UPDATE: '/school/parent-school-relation/{id}' as const,
  PROPERTIES_FOR_SCHOOL_CREATE: '/school/properties/for-school/{school_id}' as const,
  SCHOOL_PROPERTY_DELETE: '/school/property/{school_property_id}' as const,
  SCHOOL_PUBLIC_LIST_LIST: '/school/public/list' as const,
  SCHOOL_PUBLIC_DETAIL: '/school/public/{id}' as const,
  SCHOOL_PUBLIC_INVITE_LIST: '/school/public/{id}/invite/' as const,
  SCHOOL_RELATION_AVATAR_LIST: '/school/relation/{id}/avatar' as const,
  SCHOOL_RELATION_DELETE: '/school/school-relation/{id}' as const,
  SCHOOL_YEARS_FOR_SCHOOL_CREATE: '/school/school-years/for-school/{school_id}' as const,
  STAFF_SCHOOL_RELATION_PARTIAL_UPDATE: '/school/staff-school-relation/{id}' as const,
  STUDENT_SCHOOL_RELATION_PARTIAL_UPDATE: '/school/student-school-relation/{id}' as const,
  SCHOOL_DETAIL: '/school/{id}' as const,
  SCHOOL_ADD_STAFF_CREATE: '/school/{id}/add-staff/' as const,
  SCHOOL_ADD_STUDENT_CREATE: '/school/{id}/add-student/' as const,
  SCHOOL_ARRANGE_BY_AMOUNT_LIST: '/school/{id}/arrange-by-amount' as const,
  SCHOOL_BULK_INVITE_CREATE: '/school/{id}/bulk-invite' as const,
  SCHOOL_CHECK_USER_RELATION_EMAIL_LIST: '/school/{id}/check-user-relation-email' as const,
  SCHOOL_CHECK_USER_RELATION_NUMBER_LIST: '/school/{id}/check-user-relation-number' as const,
  SCHOOL_DUPLICATES_CREATE: '/school/{id}/duplicates' as const,
  SCHOOL_DUPLICATES_MARK_NOT_DUPLICATES_CREATE: '/school/{id}/duplicates/mark-not-duplicates' as const,
  SCHOOL_ELIGIBLE_RELATIONS_CREATE: '/school/{id}/eligible-relations' as const,
  SCHOOL_INVITE_TO_ACCEPT_LIST: '/school/{id}/invite-to-accept/' as const,
  SCHOOL_INVITE_CREATE: '/school/{id}/invite/' as const,
  SCHOOL_INVITE_DELETE: '/school/{id}/invite/' as const,
  SCHOOL_LOGO_LIST: '/school/{id}/logo' as const,
  SCHOOL_PARENT_MINI_LIST_LIST: '/school/{id}/parent-mini-list' as const,
  SCHOOL_PARENT_DETAIL: '/school/{id}/parent/{parent_id}' as const,
  SCHOOL_PARENTS_LIST: '/school/{id}/parents/' as const,
  SCHOOL_SETTINGS_NOTIFICATIONS_LIST: '/school/{id}/settings/notifications/' as const,
  SCHOOL_SETTINGS_NOTIFICATIONS_PARTIAL_UPDATE: '/school/{id}/settings/notifications/' as const,
  SCHOOL_STAFF_LIST: '/school/{id}/staff' as const,
  SCHOOL_STAFF_MINI_LIST_LIST: '/school/{id}/staff-mini-list' as const,
  SCHOOL_STAFF_CHART_LIST: '/school/{id}/staff/chart' as const,
  SCHOOL_STAFF_DETAIL: '/school/{id}/staff/{staff_id}' as const,
  SCHOOL_STUDENT_MINI_LIST_LIST: '/school/{id}/student-mini-list' as const,
  SCHOOL_STUDENT_DETAIL: '/school/{id}/student/{student_id}' as const,
  SCHOOL_STUDENTS_LIST: '/school/{id}/students' as const,
  SCHOOL_STUDENTS_CHART_LIST: '/school/{id}/students/chart' as const,
  SCHOOL_STUDENTS_MERGE_CREATE: '/school/{id}/students/merge' as const,
  SCHOOL_SUGGEST_CHANGES_ACCEPT_PARTIAL_UPDATE: '/school/{id}/suggest-changes/{change_id}/accept' as const,
  SCHOOL_SUGGEST_CHANGES_REJECT_PARTIAL_UPDATE: '/school/{id}/suggest-changes/{change_id}/reject' as const,
  SCHOOL_USER_COUNT_LIST: '/school/{id}/user-count' as const,
  VERIFY_SCHOOL_CREATE: '/school/{id}/verify-school' as const,
  SCHOOL_YEARS_LIST: '/school/{id}/years' as const,
  SCHOOL_YEARS_PERIOD_GROUPS_PARTIAL_UPDATE: '/school/{id}/years/{year_id}/period-groups' as const,
  SELECT_LIST_FOR_SCHOOL_CREATE: '/select_list/for-school/{school_id}/' as const,
  SELECT_LIST_FOR_SCHOOL_LIST: '/select_list/for-school/{school_id}/' as const,
  SELECT_LIST_DETAIL: '/select_list/{list_id}' as const,
  SELECT_LIST_DELETE: '/select_list/{list_id}' as const,
  SELECT_LIST_PARTIAL_UPDATE: '/select_list/{list_id}' as const,
  USER_ROLES_AVAILABLE_FOR_RELATION_DETAIL: '/user-roles/available-for-relation/{relation_id}' as const,
  USER_ROLES_CHECK_USER_ROLE_NAME_LIST: '/user-roles/check-user-role-name/' as const,
  USER_ROLES_FOR_RELATION_DETAIL: '/user-roles/for-relation/{relation_id}' as const,
  USER_ROLES_FOR_RELATION_PARTIAL_UPDATE: '/user-roles/for-relation/{relation_id}' as const,
  USER_ROLES_FOR_SCHOOL_CREATE: '/user-roles/for-school/{school_id}' as const,
  USER_ROLES_FOR_SCHOOL_DETAIL: '/user-roles/for-school/{school_id}' as const,
  USER_ROLES_DETAIL: '/user-roles/{id}' as const,
  USER_ROLES_PARTIAL_UPDATE: '/user-roles/{id}' as const,
  USER_ROLES_DELETE: '/user-roles/{id}' as const,
  USER_ROLES_CHECK_SYSTEM_ROLE_LIST: '/user-roles/{id}/check-system-role' as const,
  USER_ROLES_USERS_LIST: '/user-roles/{id}/users' as const,
  USER_ACCEPT_INVITE_CREATE: '/user/accept-invite' as const,
  USER_CHECK_PASSWORD_RESET_TOKEN_LIST: '/user/check-password-reset-token' as const,
  USER_CREATE_PASSWORD_RESET_TOKEN_CREATE: '/user/create-password-reset-token' as const,
  USER_CREATE_UNVERIFIED_EMAIL_CREATE: '/user/create-unverified-email' as const,
  CREATE_UNVERIFIED_EMAIL_FOR_USERNAME_CREATE: '/user/create-unverified-email-for-username' as const,
  USER_CREATE_UNVERIFIED_EMAIL_PUBLIC_CREATE: '/user/create-unverified-email/public' as const,
  USER_DB_CONSISTENCY_CHECK_LIST: '/user/db_consistency_check' as const,
  USER_EMAIL_IN_USE_FOR_SCHOOL_CREATE: '/user/email-in-use/for-school/{school_id}' as const,
  USER_EMAIL_IN_USE_PUBLIC_CREATE: '/user/email-in-use/public' as const,
  USER_FILTERS_LIST: '/user/filters' as const,
  USER_FILTERS_CREATE: '/user/filters' as const,
  USER_FILTERS_LIST2: '/user/filters/{filter_id}/' as const,
  USER_FILTERS_PARTIAL_UPDATE: '/user/filters/{filter_id}/' as const,
  USER_FILTERS_DELETE: '/user/filters/{filter_id}/' as const,
  USER_HEALTHCHECK_LIST: '/user/healthcheck' as const,
  USER_MERGE_CHILDREN_CREATE: '/user/merge/children' as const,
  USER_NOTIFICATIONS_LIST: '/user/notifications' as const,
  USER_NOTIFICATIONS_DELETE: '/user/notifications/{notification_id}' as const,
  USER_NOTIFICATIONS_READ_PARTIAL_UPDATE: '/user/notifications/{notification_id}/read' as const,
  USER_PARENT_CREATE: '/user/parent' as const,
  USER_PUSH_TOKEN_CREATE: '/user/push_token' as const,
  USER_PUSH_TOKEN_PARTIAL_UPDATE: '/user/push_token' as const,
  USER_PUSH_TOKEN_DELETE: '/user/push_token' as const,
  USER_SET_CONTACT_EMAIL_CREATE: '/user/set-contact-email' as const,
  USER_SYNC_CREATE: '/user/sync' as const,
  UPDATE_USER_PASSWORD_PARTIAL_UPDATE: '/user/update-user-password' as const,
  USER_VERIFY_CONTACT_EMAIL_CREATE: '/user/verify-contact-email' as const,
  USER_VERIFY_EMAIL_CREATE: '/user/verify-email' as const,
  VERIFY_EMAIL_FOR_USERNAME_CREATE: '/user/verify-email-for-username' as const,
  USER_VERIFY_EMAIL_SIGNUP_CREATE: '/user/verify-email-signup' as const,
  USER_LIST: '/user/{id}/' as const,
  USER_PARTIAL_UPDATE: '/user/{id}/' as const,
  USER_DELETE: '/user/{id}/' as const,
  USER_ACCOUNT_DELETE: '/user/{id}/account' as const,
  USER_AVATAR_LIST: '/user/{id}/avatar' as const,
} as const;

export const buildApplicationAvailableAdultsListPath = () => '/application/available-adults';

export const buildApplicationCreateCreatePath = (params: { school_id: string }) => `/application/create/${params.school_id}`;

export const buildApplicationCreatePublicCreatePath = (params: { school_id: string }) => `/application/create/${params.school_id}/public`;

export const buildApplicationCreateStaffCreatePath = (params: { school_id: string }) => `/application/create/${params.school_id}/staff`;

export const buildApplicationForChildrenListPath = () => '/application/for-children';

export const buildApplicationListListPath = () => '/application/list';

export const buildApplicationParentListListPath = () => '/application/parent/list';

export const buildApplicationDetailPath = (params: { application_id: string }) => `/application/${params.application_id}`;

export const buildApplicationPartialUpdatePath = (params: { application_id: string }) => `/application/${params.application_id}`;

export const buildApplicationConvertPartialUpdatePath = (params: { application_id: string }) => `/application/${params.application_id}/convert`;

export const buildApplicationNotesPartialUpdatePath = (params: { application_id: string }) => `/application/${params.application_id}/notes`;

export const buildApplicationRejectPartialUpdatePath = (params: { application_id: string }) => `/application/${params.application_id}/reject`;

export const buildAssessmentEntriesForMethodForRelationCreatePath = (params: { method_id: string; recipient_relation_id: string }) => `/assessment/entries/for-method/${params.method_id}/for-relation/${params.recipient_relation_id}/`;

export const buildAssessmentForGroupDetailPath = (params: { group_id: string }) => `/assessment/for-group/${params.group_id}`;

export const buildAssessmentForGroupEntriesListPath = (params: { group_id: string }) => `/assessment/for-group/${params.group_id}/entries`;

export const buildAssessmentForProfileDetailPath = (params: { profile_id: string }) => `/assessment/for-profile/${params.profile_id}`;

export const buildAssessmentForProfileEntriesListPath = (params: { profile_id: string }) => `/assessment/for-profile/${params.profile_id}/entries`;

export const buildAssessmentForProfileOverviewListPath = (params: { profile_id: string }) => `/assessment/for-profile/${params.profile_id}/overview`;

export const buildAssessmentForRelationEntriesListPath = (params: { relation_id: string }) => `/assessment/for-relation/${params.relation_id}/entries`;

export const buildAssessmentForSchoolListPath = (params: { school_id: string }) => `/assessment/for-school/${params.school_id}/`;

export const buildAssessmentForSchoolCreatePath = (params: { school_id: string }) => `/assessment/for-school/${params.school_id}/`;

export const buildAssessmentForSchoolAggregateListPath = (params: { school_id: string }) => `/assessment/for-school/${params.school_id}/aggregate`;

export const buildAssessmentDetailPath = (params: { assessment_id: string }) => `/assessment/${params.assessment_id}`;

export const buildAssessmentDeletePath = (params: { assessment_id: string }) => `/assessment/${params.assessment_id}/`;

export const buildAssessmentPartialUpdatePath = (params: { assessment_id: string }) => `/assessment/${params.assessment_id}/`;

export const buildAssessmentActionCreatePath = (params: { assessment_id: string }) => `/assessment/${params.assessment_id}/action`;

export const buildAssessmentGroupsListPath = (params: { assessment_id: string }) => `/assessment/${params.assessment_id}/groups`;

export const buildAttendanceAbsenceCreatePath = () => '/attendance/absence';

export const buildCodesForAttendancePartialUpdatePath = (params: { attendance_code_id: string }) => `/attendance/codes/for-attendance/${params.attendance_code_id}/`;

export const buildAttendanceCodesForSchoolCreatePath = (params: { school_id: string }) => `/attendance/codes/for-school/${params.school_id}/`;

export const buildAttendanceCodesForSchoolListPath = (params: { school_id: string }) => `/attendance/codes/for-school/${params.school_id}/`;

export const buildAttendanceCodesOrderForSchoolPartialUpdatePath = (params: { school_id: string }) => `/attendance/codes/order/for-school/${params.school_id}/`;

export const buildAttendanceCodesDeletePath = (params: { code_id: string }) => `/attendance/codes/${params.code_id}/`;

export const buildAttendanceEntriesForRegisterForRelationCreatePath = (params: { register_id: string; relation_id: string }) => `/attendance/entries/for-register/${params.register_id}/for-relation/${params.relation_id}`;

export const buildAttendanceForGroupEntriesCreatePath = (params: { group_id: string }) => `/attendance/for-group/${params.group_id}/entries`;

export const buildAttendanceForGroupEntriesForDateListPath = (params: { group_id: string }) => `/attendance/for-group/${params.group_id}/entries/for-date`;

export const buildAttendanceForGroupEntriesForPeriodListPath = (params: { group_id: string }) => `/attendance/for-group/${params.group_id}/entries/for-period`;

export const buildAttendanceForProfileEntriesDetailPath = (params: { profile_id: string; attendance_code_id: string }) => `/attendance/for-profile/${params.profile_id}/entries/${params.attendance_code_id}`;

export const buildAttendanceForProfileOverviewListPath = (params: { profile_id: string }) => `/attendance/for-profile/${params.profile_id}/overview`;

export const buildAttendanceForRelationEntriesListPath = (params: { relation_id: string }) => `/attendance/for-relation/${params.relation_id}/entries`;

export const buildAttendanceRegisterForSchoolCreatePath = (params: { school_id: string }) => `/attendance/register-for-school/${params.school_id}/`;

export const buildAttendanceRegisterListPath = (params: { register_id: string }) => `/attendance/register/${params.register_id}/`;

export const buildAttendanceRegisterDeletePath = (params: { register_id: string }) => `/attendance/register/${params.register_id}/`;

export const buildAttendanceRegisterPartialUpdatePath = (params: { register_id: string }) => `/attendance/register/${params.register_id}/`;

export const buildAttendanceRegistersForSchoolListPath = (params: { school_id: string }) => `/attendance/registers-for-school/${params.school_id}/`;

export const buildAttendanceRegistersForSchoolStatisticsListPath = (params: { school_id: string }) => `/attendance/registers-for-school/${params.school_id}/statistics`;

export const buildBillingCountListPath = () => '/billing/count';

export const buildBillingFrequenciesListPath = () => '/billing/frequencies';

export const buildBillingFrequenciesPartialUpdatePath = (params: { frequency_id: string }) => `/billing/frequencies/${params.frequency_id}`;

export const buildBillingInvoiceAggregatedListPath = () => '/billing/invoice/aggregated';

export const buildBillingLegalEntitiesListPath = () => '/billing/legal-entities';

export const buildBillingLegalEntitiesCreatePath = () => '/billing/legal-entities';

export const buildBillingLegalEntitiesValidateLegalEntityCreatePath = () => '/billing/legal-entities/validate-legal-entity';

export const buildBillingLegalEntitiesDetailPath = (params: { legal_entity_id: string }) => `/billing/legal-entities/${params.legal_entity_id}`;

export const buildBillingLegalEntitiesPartialUpdatePath = (params: { legal_entity_id: string }) => `/billing/legal-entities/${params.legal_entity_id}`;

export const buildBillingLegalEntitiesDeletePath = (params: { legal_entity_id: string }) => `/billing/legal-entities/${params.legal_entity_id}`;

export const buildConductCommentForEntryCreatePath = (params: { entry_id: string }) => `/conduct/comment/for-entry/${params.entry_id}/`;

export const buildConductCommentPartialUpdatePath = (params: { conduct_comment_id: string }) => `/conduct/comment/${params.conduct_comment_id}/`;

export const buildConductEntriesForSchoolListPath = (params: { school_id: string }) => `/conduct/entries/for-school/${params.school_id}/`;

export const buildConductEntriesForSchoolAggregateListPath = (params: { school_id: string }) => `/conduct/entries/for-school/${params.school_id}/aggregate`;

export const buildConductEntriesForTypeCreatePath = (params: { conduct_type_id: string }) => `/conduct/entries/for-type/${params.conduct_type_id}/`;

export const buildConductEntriesProfilesListPath = (params: { profile_id: string }) => `/conduct/entries/profiles/${params.profile_id}/`;

export const buildConductEntriesPartialUpdatePath = (params: { conduct_entry_id: string }) => `/conduct/entries/${params.conduct_entry_id}/`;

export const buildConductEntriesDeletePath = (params: { conduct_entry_id: string }) => `/conduct/entries/${params.conduct_entry_id}/`;

export const buildHandleConductTypesCreatePath = (params: { school_id: string }) => `/conduct/handle-conduct-types/${params.school_id}`;

export const buildConductStatsForSchoolListPath = (params: { school_id: string }) => `/conduct/stats/for-school/${params.school_id}/`;

export const buildConductTypeDetailPath = (params: { conduct_type_id: string }) => `/conduct/type/${params.conduct_type_id}`;

export const buildConductTypeDeletePath = (params: { conduct_type_id: string }) => `/conduct/type/${params.conduct_type_id}`;

export const buildConductTypePartialUpdatePath = (params: { conduct_type_id: string }) => `/conduct/type/${params.conduct_type_id}`;

export const buildConductTypesForSchoolCreatePath = (params: { school_id: string }) => `/conduct/types/for-school/${params.school_id}/`;

export const buildConductTypesForSchoolListPath = (params: { school_id: string }) => `/conduct/types/for-school/${params.school_id}/`;

export const buildConsentFormCreatePath = () => '/consent-form';

export const buildConsentFormForRelationDetailPath = (params: { relation_id: string }) => `/consent-form/for-relation/${params.relation_id}`;

export const buildConsentFormForRelationHistoryListPath = (params: { relation_id: string }) => `/consent-form/for-relation/${params.relation_id}/history`;

export const buildConsentFormParentHistoryListPath = () => '/consent-form/parent/history';

export const buildConsentFormParentDetailPath = (params: { consent_form_id: string }) => `/consent-form/parent/${params.consent_form_id}`;

export const buildConsentFormParentHistoryList2Path = (params: { consent_form_id: string }) => `/consent-form/parent/${params.consent_form_id}/history`;

export const buildConsentFormDeletePath = (params: { consent_form_id: string }) => `/consent-form/${params.consent_form_id}`;

export const buildConsentFormPartialUpdatePath = (params: { consent_form_id: string }) => `/consent-form/${params.consent_form_id}`;

export const buildConsentFormDetailPath = (params: { consent_form_id: string }) => `/consent-form/${params.consent_form_id}`;

export const buildConsentFormItemsListPath = (params: { consent_form_id: string }) => `/consent-form/${params.consent_form_id}/items`;

export const buildConsentFormSignCreatePath = (params: { consent_form_id: string }) => `/consent-form/${params.consent_form_id}/sign`;

export const buildCustomFieldForSchoolDetailPath = (params: { school_id: string }) => `/custom_field/for-school/${params.school_id}`;

export const buildCustomFieldForSchoolCreatePath = (params: { school_id: string }) => `/custom_field/for-school/${params.school_id}/`;

export const buildCustomFieldForSchoolPublicListPath = (params: { school_id: string }) => `/custom_field/for-school/${params.school_id}/public`;

export const buildCustomFieldValueForRelationDetailPath = (params: { relation_id: string }) => `/custom_field/value/for-relation/${params.relation_id}`;

export const buildCustomFieldValueForRelationCreatePath = (params: { relation_id: string }) => `/custom_field/value/for-relation/${params.relation_id}`;

export const buildCustomFieldPartialUpdatePath = (params: { id: string }) => `/custom_field/${params.id}`;

export const buildCustomFieldDeletePath = (params: { id: string }) => `/custom_field/${params.id}`;

export const buildDirectoryFiltersListPath = () => '/directory/filters';

export const buildDirectoryLocationListPath = () => '/directory/location';

export const buildDirectorySchoolListPath = () => '/directory/school';

export const buildDirectorySchoolDetailPath = (params: { school_id: string }) => `/directory/school/${params.school_id}`;

export const buildDirectorySchoolEnquireCreatePath = (params: { school_id: string }) => `/directory/school/${params.school_id}/enquire`;

export const buildDirectorySchoolMySchoolCreatePath = (params: { school_id: string }) => `/directory/school/${params.school_id}/my-school`;

export const buildEventsForParentListPath = () => '/events/for-parent';

export const buildEventsForParentDetailPath = (params: { event_id: string }) => `/events/for-parent/${params.event_id}`;

export const buildEventsForSchoolCreatePath = (params: { school_id: string }) => `/events/for-school/${params.school_id}/`;

export const buildEventsForSchoolListPath = (params: { school_id: string }) => `/events/for-school/${params.school_id}/`;

export const buildEventsForSchoolActionCreatePath = (params: { school_id: string }) => `/events/for-school/${params.school_id}/action`;

export const buildEventsForSchoolAggregateListPath = (params: { school_id: string }) => `/events/for-school/${params.school_id}/aggregate`;

export const buildEventsSignUpsForParentListPath = () => '/events/sign-ups/for-parent';

export const buildEventsSignUpsForParentCreatePath = () => '/events/sign-ups/for-parent';

export const buildEventsSignUpsForParentDetailPath = (params: { sign_up_id: string }) => `/events/sign-ups/for-parent/${params.sign_up_id}`;

export const buildEventsSignUpsForParentPartialUpdatePath = (params: { sign_up_id: string }) => `/events/sign-ups/for-parent/${params.sign_up_id}`;

export const buildEventsSignUpsForParentCancelDeletePath = (params: { sign_up_id: string }) => `/events/sign-ups/for-parent/${params.sign_up_id}/cancel`;

export const buildEventsSignUpsForSchoolDetailPath = (params: { school_id: string }) => `/events/sign-ups/for-school/${params.school_id}`;

export const buildEventsSignUpsForSchoolCreatePath = (params: { school_id: string }) => `/events/sign-ups/for-school/${params.school_id}`;

export const buildEventsSignUpsForSchoolActionCreatePath = (params: { school_id: string }) => `/events/sign-ups/for-school/${params.school_id}/action`;

export const buildEventsSignUpsPartialUpdatePath = (params: { sign_up_id: string }) => `/events/sign-ups/${params.sign_up_id}`;

export const buildEventsSignUpsDeletePath = (params: { sign_up_id: string }) => `/events/sign-ups/${params.sign_up_id}`;

export const buildEventsSignUpsDetailPath = (params: { sign_up_id: string }) => `/events/sign-ups/${params.sign_up_id}`;

export const buildEventsSignUpsRespondentsListPath = (params: { sign_up_id: string }) => `/events/sign-ups/${params.sign_up_id}/respondents`;

export const buildEventsPartialUpdatePath = (params: { event_id: string }) => `/events/${params.event_id}/`;

export const buildEventsDeletePath = (params: { event_id: string }) => `/events/${params.event_id}/`;

export const buildEventsListPath = (params: { event_id: string }) => `/events/${params.event_id}/`;

export const buildExportAssessmentForGroupDetailPath = (params: { group_id: string }) => `/export/assessment/for-group/${params.group_id}`;

export const buildExportAssessmentForRelationDetailPath = (params: { relation_id: string }) => `/export/assessment/for-relation/${params.relation_id}`;

export const buildExportAssessmentSingleDetailPath = (params: { assessment_id: string }) => `/export/assessment/single/${params.assessment_id}`;

export const buildExportAttendanceForGroupDetailPath = (params: { group_id: string }) => `/export/attendance/for-group/${params.group_id}`;

export const buildExportAttendanceRegisterDetailPath = (params: { register_id: string }) => `/export/attendance/register/${params.register_id}`;

export const buildExportAttendanceDetailPath = (params: { school_id: string }) => `/export/attendance/${params.school_id}`;

export const buildExportConductForGroupDetailPath = (params: { group_id: string }) => `/export/conduct/for-group/${params.group_id}`;

export const buildExportConductForRelationDetailPath = (params: { relation_id: string }) => `/export/conduct/for-relation/${params.relation_id}`;

export const buildExportConductDetailPath = (params: { school_id: string }) => `/export/conduct/${params.school_id}`;

export const buildExportConsentFormDetailPath = (params: { consent_form_id: string }) => `/export/consent-form/${params.consent_form_id}`;

export const buildExportReportsForProfileDetailPath = (params: { profile_id: string }) => `/export/reports/for-profile/${params.profile_id}`;

export const buildExportSignUpsRespondentsDetailPath = (params: { sign_up_id: string }) => `/export/sign-ups/respondents/${params.sign_up_id}`;

export const buildExportStudentsDetailPath = (params: { group_id: string }) => `/export/students/${params.group_id}`;

export const buildExportTermsAndConditionsDetailPath = (params: { id: string }) => `/export/terms-and-conditions/${params.id}`;

export const buildGroupsListPath = () => '/groups';

export const buildGroupsCreatePath = () => '/groups';

export const buildGroupsAggregateListPath = () => '/groups/aggregate';

export const buildGroupsAvailableCriteriaListPath = () => '/groups/available-criteria';

export const buildGroupsAvailableCriteriaByCountListPath = () => '/groups/available-criteria-by-count';

export const buildGroupsAvailableForRelationDetailPath = (params: { relation_id: string }) => `/groups/available-for-relation/${params.relation_id}`;

export const buildGroupsCheckGroupNameListPath = () => '/groups/check-group-name';

export const buildGroupsCheckUniquenessListPath = () => '/groups/check-uniqueness';

export const buildGroupsCreateSubjectsCreatePath = () => '/groups/create-subjects';

export const buildGroupsExportListPath = () => '/groups/export';

export const buildGroupsForProfileDetailPath = (params: { profile_id: string }) => `/groups/for-profile/${params.profile_id}`;

export const buildGroupsForRelationPartialUpdatePath = (params: { relation_id: string }) => `/groups/for-relation/${params.relation_id}`;

export const buildGroupsForRelationDetailPath = (params: { relation_id: string }) => `/groups/for-relation/${params.relation_id}`;

export const buildGroupsForUserDetailPath = (params: { id: string }) => `/groups/for-user/${params.id}`;

export const buildGroupsHandleSubjectsCreatePath = (params: { school_id: string }) => `/groups/handle-subjects/${params.school_id}`;

export const buildGroupsMembersForGroupDetailPath = (params: { id: string }) => `/groups/members-for-group/${params.id}`;

export const buildGroupsMembershipsDatesPartialUpdatePath = (params: { group_id: string }) => `/groups/memberships-dates/${params.group_id}`;

export const buildGroupsSubjectsListPath = () => '/groups/subjects';

export const buildGroupsSubjectsAttendancePartialUpdatePath = (params: { school_id: string }) => `/groups/subjects/attendance/${params.school_id}`;

export const buildGroupsDetailPath = (params: { id: string }) => `/groups/${params.id}`;

export const buildGroupsPartialUpdatePath = (params: { id: string }) => `/groups/${params.id}`;

export const buildGroupsDeletePath = (params: { id: string }) => `/groups/${params.id}`;

export const buildIntegrationWebhookHandleUnknownCreatePath = () => '/integration/webhook-handle-unknown';

export const buildIntegrationXeroResetListPath = () => '/integration/xero-reset';

export const buildIntegrationXeroTestSuperSecretListPath = () => '/integration/xero-test-super-secret';

export const buildIntegrationXeroCheckListPath = () => '/integration/xero/check';

export const buildIntegrationXeroRefreshCreatePath = () => '/integration/xero/refresh';

export const buildIntegrationXeroSetupCreatePath = () => '/integration/xero/setup';

export const buildInvoicesAccountsDetailPath = (params: { school_id: string }) => `/invoices/accounts/${params.school_id}`;

export const buildInvoicesActionCreatePath = () => '/invoices/action';

export const buildInvoicesCompaniesForSchoolCreatePath = (params: { school_id: string }) => `/invoices/companies/for-school/${params.school_id}`;

export const buildInvoicesCompaniesForSchoolDetailPath = (params: { school_id: string }) => `/invoices/companies/for-school/${params.school_id}`;

export const buildInvoicesCompaniesForSchoolValidateCompanyCreatePath = (params: { school_id: string }) => `/invoices/companies/for-school/${params.school_id}/validate-company`;

export const buildInvoicesCompaniesPartialUpdatePath = (params: { company_id: string }) => `/invoices/companies/${params.company_id}`;

export const buildInvoicesCompaniesDeletePath = (params: { company_id: string }) => `/invoices/companies/${params.company_id}`;

export const buildInvoicesCompaniesDetailPath = (params: { company_id: string }) => `/invoices/companies/${params.company_id}`;

export const buildInvoicesFrequenciesDetailPath = (params: { school_id: string }) => `/invoices/frequencies/${params.school_id}`;

export const buildInvoicesInvoiceForParentListPath = () => '/invoices/invoice/for-parent';

export const buildInvoicesInvoiceForParentStatisticsListPath = () => '/invoices/invoice/for-parent/statistics';

export const buildInvoicesInvoiceForParentDetailPath = (params: { invoice_id: string }) => `/invoices/invoice/for-parent/${params.invoice_id}`;

export const buildInvoicesInvoiceForSchoolListPath = () => '/invoices/invoice/for-school';

export const buildInvoicesInvoiceForSchoolStatisticsListPath = () => '/invoices/invoice/for-school/statistics';

export const buildInvoicesProductsAssignmentPreviewCreatePath = () => '/invoices/products/assignment-preview';

export const buildInvoicesProductsForParentDetailPath = (params: { school_relation_id: string }) => `/invoices/products/for-parent/${params.school_relation_id}`;

export const buildInvoicesProductsForRelationDetailPath = (params: { school_relation_id: string }) => `/invoices/products/for-relation/${params.school_relation_id}`;

export const buildInvoicesProductsForRelationPartialUpdatePath = (params: { school_relation_id: string }) => `/invoices/products/for-relation/${params.school_relation_id}`;

export const buildInvoicesProductsForSchoolDetailPath = (params: { school_id: string }) => `/invoices/products/for-school/${params.school_id}`;

export const buildInvoicesProductsForSchoolCreatePath = (params: { school_id: string }) => `/invoices/products/for-school/${params.school_id}`;

export const buildInvoicesProductsForSchoolValidateNameCreatePath = (params: { school_id: string }) => `/invoices/products/for-school/${params.school_id}/validate-name`;

export const buildInvoicesProductsDetailPath = (params: { product_id: string }) => `/invoices/products/${params.product_id}`;

export const buildInvoicesProductsPartialUpdatePath = (params: { product_id: string }) => `/invoices/products/${params.product_id}`;

export const buildInvoicesProductsDeletePath = (params: { product_id: string }) => `/invoices/products/${params.product_id}`;

export const buildSingleInvoicesCreatePath = () => '/invoices/single-invoices';

export const buildInvoicesStudentsForCompanyDetailPath = (params: { company_id: string }) => `/invoices/students/for-company/${params.company_id}`;

export const buildInvoicesStudentsForParentDetailPath = (params: { school_relation_id: string }) => `/invoices/students/for-parent/${params.school_relation_id}`;

export const buildInvoicesStudentsForSchoolDetailPath = (params: { school_id: string }) => `/invoices/students/for-school/${params.school_id}`;

export const buildInvoicesDetailPath = (params: { invoice_id: string }) => `/invoices/${params.invoice_id}`;

export const buildInvoicesPartialUpdatePath = (params: { invoice_id: string }) => `/invoices/${params.invoice_id}`;

export const buildMessagesArchivePartialUpdatePath = (params: { message_id: string }) => `/messages/archive/${params.message_id}/`;

export const buildMessagesCreateCreatePath = () => '/messages/create/';

export const buildMessagesFileListPath = (params: { id: string }) => `/messages/file/${params.id}/`;

export const buildMessagesForGroupListPath = (params: { id: string }) => `/messages/for-group/${params.id}/`;

export const buildMessagesForProfileSingleMessageDetailPath = (params: { message_id: string }) => `/messages/for-profile/single-message/${params.message_id}`;

export const buildMessagesForRelationListPath = (params: { id: string }) => `/messages/for-relation/${params.id}/`;

export const buildMessagesForSchoolListPath = (params: { school_id: string }) => `/messages/for-school/${params.school_id}/`;

export const buildMessagesForSchoolAggregateListPath = (params: { school_id: string }) => `/messages/for-school/${params.school_id}/aggregate`;

export const buildMessagesForSchoolCountsListPath = (params: { school_id: string }) => `/messages/for-school/${params.school_id}/counts`;

export const buildMessagesInternalDetailPath = (params: { message_id: string }) => `/messages/internal/${params.message_id}`;

export const buildMessagesInternalParticipantsListPath = (params: { message_id: string }) => `/messages/internal/${params.message_id}/participants`;

export const buildMessagesLabelListPath = () => '/messages/label/';

export const buildMessagesLabelPartialUpdatePath = (params: { message_id: string }) => `/messages/label/${params.message_id}/`;

export const buildMessagesParentListPath = () => '/messages/parent/';

export const buildMessagesUserListPath = () => '/messages/user/';

export const buildMessagesPartialUpdatePath = (params: { id: string }) => `/messages/${params.id}/`;

export const buildMessagesDeletePath = (params: { id: string }) => `/messages/${params.id}/`;

export const buildMessagesActionCreatePath = (params: { id: string }) => `/messages/${params.id}/action`;

export const buildMessagesReadPartialUpdatePath = (params: { id: string }) => `/messages/${params.id}/read`;

export const buildMessagesListPath = (params: { message_id: string }) => `/messages/${params.message_id}/`;

export const buildProfileAddFamilyCreatePath = () => '/profile/add-family';

export const buildProfileAdultInvitesCreatePath = () => '/profile/adult-invites';

export const buildProfileAdultInvitesDeletePath = (params: { adult_id: string }) => `/profile/adult-invites/${params.adult_id}`;

export const buildProfileAdultInvitesResendCreatePath = (params: { adult_id: string }) => `/profile/adult-invites/${params.adult_id}/resend`;

export const buildProfileAdultsDeletePath = (params: { adult_id: string }) => `/profile/adults/${params.adult_id}`;

export const buildProfileAdultsPartialUpdatePath = (params: { adult_id: string }) => `/profile/adults/${params.adult_id}`;

export const buildProfileAdultsUpdatePath = (params: { adult_id: string }) => `/profile/adults/${params.adult_id}`;

export const buildProfileAdultsChildDeletePath = (params: { adult_id: string; child_id: string }) => `/profile/adults/${params.adult_id}/child/${params.child_id}`;

export const buildProfileAdultsChildrenListPath = (params: { adult_id: string }) => `/profile/adults/${params.adult_id}/children`;

export const buildProfileApplicationSettingsForParentCreatePath = () => '/profile/application-settings/for-parent';

export const buildProfileApplicationSettingsForParentPartialUpdatePath = () => '/profile/application-settings/for-parent';

export const buildProfileChildrenCreatePath = () => '/profile/children';

export const buildProfileChildrenDetailPath = (params: { child_id: string }) => `/profile/children/${params.child_id}`;

export const buildProfileChildrenMedicalNeedsCreatePath = (params: { child_id: string }) => `/profile/children/${params.child_id}/medical-needs`;

export const buildProfileChildrenMedicalNeedsPartialUpdatePath = (params: { child_id: string; medical_needs_id: string }) => `/profile/children/${params.child_id}/medical-needs/${params.medical_needs_id}`;

export const buildProfileConnectWhatsappForParentCreatePath = () => '/profile/connect-whatsapp/for-parent';

export const buildProfileCountersDetailPath = (params: { profile_id: string }) => `/profile/counters/${params.profile_id}`;

export const buildDemoProfileListPath = () => '/profile/demo-profile/';

export const buildProfileEditFamilyPartialUpdatePath = () => '/profile/edit-family';

export const buildProfileFeedbackCreatePath = () => '/profile/feedback/';

export const buildProfileListListPath = () => '/profile/list/';

export const buildProfileNotificationsSettingsForParentPartialUpdatePath = () => '/profile/notifications-settings/for-parent';

export const buildProfileRequestWhatsappCodeForParentCreatePath = () => '/profile/request-whatsapp-code/for-parent';

export const buildRegistrationAdmissionsAggregateListPath = () => '/registration/admissions/aggregate';

export const buildRegistrationEmploymentsListPath = () => '/registration/employments';

export const buildRegistrationEmploymentsCreatePath = () => '/registration/employments';

export const buildRegistrationEmploymentsPartialUpdatePath = (params: { employment_id: string }) => `/registration/employments/${params.employment_id}`;

export const buildRegistrationEmploymentsDeletePath = (params: { employment_id: string }) => `/registration/employments/${params.employment_id}`;

export const buildRegistrationEnrollmentsListPath = () => '/registration/enrollments';

export const buildRegistrationEnrollmentsCreatePath = () => '/registration/enrollments';

export const buildRegistrationEnrollmentsReEnrollmentPartialUpdatePath = (params: { re_enrollment_id: string }) => `/registration/enrollments/re-enrollment/${params.re_enrollment_id}`;

export const buildRegistrationEnrollmentsPartialUpdatePath = (params: { enrollment_id: string }) => `/registration/enrollments/${params.enrollment_id}`;

export const buildRegistrationEnrollmentsDeletePath = (params: { enrollment_id: string }) => `/registration/enrollments/${params.enrollment_id}`;

export const buildRegistrationReenrolmentsCreatePath = () => '/registration/reenrolments';

export const buildRegistrationReenrolmentsAssignmentPreviewCreatePath = () => '/registration/reenrolments/assignment-preview';

export const buildRegistrationStudentsRolloverCreatePath = () => '/registration/students/rollover';

export const buildRegistrationStudentsRolloverAggregateCreatePath = () => '/registration/students/rollover/aggregate';

export const buildRegistrationStudentsRolloverInconsistenciesCreatePath = () => '/registration/students/rollover/inconsistencies';

export const buildRegistrationStudentsRolloverInconsistenciesListCreatePath = () => '/registration/students/rollover/inconsistencies/list';

export const buildReportsForProfileListPath = (params: { profile_id: string }) => `/reports/for-profile/${params.profile_id}/`;

export const buildReportsForProfilePaginatedListPath = (params: { profile_id: string }) => `/reports/for-profile/${params.profile_id}/paginated`;

export const buildReportsForRelationDetailPath = (params: { relation_id: string }) => `/reports/for-relation/${params.relation_id}`;

export const buildReportsForSchoolListPath = (params: { school_id: string }) => `/reports/for-school/${params.school_id}/`;

export const buildReportsForSchoolCreatePath = (params: { school_id: string }) => `/reports/for-school/${params.school_id}/`;

export const buildReportsForSchoolAreasOfLearningListPath = (params: { school_id: string }) => `/reports/for-school/${params.school_id}/areas-of-learning/`;

export const buildReportsForSchoolPossibleAssessmentsCreatePath = (params: { school_id: string }) => `/reports/for-school/${params.school_id}/possible-assessments/`;

export const buildReportsDetailPath = (params: { report_id: string }) => `/reports/${params.report_id}`;

export const buildReportsDeletePath = (params: { report_id: string }) => `/reports/${params.report_id}/`;

export const buildReportsPartialUpdatePath = (params: { report_id: string }) => `/reports/${params.report_id}/`;

export const buildReportsActionCreatePath = (params: { report_id: string }) => `/reports/${params.report_id}/action`;

export const buildReportsRecipientsListPath = (params: { report_id: string }) => `/reports/${params.report_id}/recipients`;

export const buildSchoolDetailsSchoolCancelLeavingSchoolCreatePath = (params: { school_id: string }) => `/school_details/school/${params.school_id}/cancel-leaving-school`;

export const buildSchoolDetailsSchoolLeaveSchoolCreatePath = (params: { school_id: string; child_id: string }) => `/school_details/school/${params.school_id}/leave-school/${params.child_id}/`;

export const buildSchoolDetailsSchoolPropertiesListPath = (params: { school_id: string }) => `/school_details/school/${params.school_id}/properties`;

export const buildSchoolDetailsSchoolSettingsListPath = (params: { school_id: string }) => `/school_details/school/${params.school_id}/settings`;

export const buildSchoolDetailsSchoolSettingsLeavingSchoolListPath = (params: { school_id: string }) => `/school_details/school/${params.school_id}/settings/leaving-school`;

export const buildSchoolDetailsSchoolSettingsLeavingSchoolCreatePath = (params: { school_id: string }) => `/school_details/school/${params.school_id}/settings/leaving-school`;

export const buildSchoolDetailsSchoolSettingsLeavingSchoolReasonsListPath = (params: { school_id: string }) => `/school_details/school/${params.school_id}/settings/leaving-school/reasons/`;

export const buildSchoolDetailsSchoolSettingsLeavingSchoolReasonsCreatePath = (params: { school_id: string }) => `/school_details/school/${params.school_id}/settings/leaving-school/reasons/`;

export const buildSchoolDetailsSchoolSettingsReEnrollmentListPath = (params: { school_id: string }) => `/school_details/school/${params.school_id}/settings/re-enrollment`;

export const buildSchoolDetailsSchoolSettingsReEnrollmentPartialUpdatePath = (params: { school_id: string }) => `/school_details/school/${params.school_id}/settings/re-enrollment`;

export const buildSchoolDetailsSchoolSettingsTermsAndConditionsPartialUpdatePath = (params: { school_id: string }) => `/school_details/school/${params.school_id}/settings/terms-and-conditions`;

export const buildSchoolDetailsSchoolYearsListPath = (params: { school_id: string }) => `/school_details/school/${params.school_id}/years`;

export const buildSchoolDetailsSchoolsForParentListPath = () => '/school_details/schools/for-parent';

export const buildSchoolDetailsSchoolsForParentDetailPath = (params: { school_id: string }) => `/school_details/schools/for-parent/${params.school_id}`;

export const buildSchoolDetailsSchoolsForParentEnrolmentHistoryDetailPath = (params: { school_id: string; child_id: string }) => `/school_details/schools/for-parent/${params.school_id}/enrolment-history/${params.child_id}`;

export const buildSchoolDetailsAgeGroupsPartialUpdatePath = (params: { id: string }) => `/school_details/${params.id}/age_groups`;

export const buildSchoolDetailsPlanDetailPath = (params: { id: string; year_id: string }) => `/school_details/${params.id}/plan/${params.year_id}`;

export const buildSchoolChangeDefaultValuesForPropertiesCreatePath = (params: { school_id: string }) => `/school/change-default-values-for-properties/${params.school_id}`;

export const buildChangeLastSchoolCreatePath = () => '/school/change-last-school';

export const buildCreateSchoolCreatePath = () => '/school/create-school';

export const buildCreateSchoolWithPropsCreatePath = () => '/school/create-school-with-props';

export const buildEditSchoolPartialUpdatePath = () => '/school/edit-school';

export const buildSchoolGetCategoriesListPath = () => '/school/get-categories';

export const buildSchoolHandleDepartmentsCreatePath = (params: { school_id: string }) => `/school/handle-departments/${params.school_id}`;

export const buildSchoolHandleHousesCreatePath = (params: { school_id: string }) => `/school/handle-houses/${params.school_id}`;

export const buildHandleSchoolYearsCreatePath = (params: { school_id: string }) => `/school/handle-school-years/${params.school_id}`;

export const buildSchoolHandleStatusesCreatePath = (params: { school_id: string }) => `/school/handle-statuses/${params.school_id}`;

export const buildParentSchoolRelationPartialUpdatePath = (params: { id: string }) => `/school/parent-school-relation/${params.id}`;

export const buildPropertiesForSchoolCreatePath = (params: { school_id: string }) => `/school/properties/for-school/${params.school_id}`;

export const buildSchoolPropertyDeletePath = (params: { school_property_id: string }) => `/school/property/${params.school_property_id}`;

export const buildSchoolPublicListListPath = () => '/school/public/list';

export const buildSchoolPublicDetailPath = (params: { id: string }) => `/school/public/${params.id}`;

export const buildSchoolPublicInviteListPath = (params: { id: string }) => `/school/public/${params.id}/invite/`;

export const buildSchoolRelationAvatarListPath = (params: { id: string }) => `/school/relation/${params.id}/avatar`;

export const buildSchoolRelationDeletePath = (params: { id: string }) => `/school/school-relation/${params.id}`;

export const buildSchoolYearsForSchoolCreatePath = (params: { school_id: string }) => `/school/school-years/for-school/${params.school_id}`;

export const buildStaffSchoolRelationPartialUpdatePath = (params: { id: string }) => `/school/staff-school-relation/${params.id}`;

export const buildStudentSchoolRelationPartialUpdatePath = (params: { id: string }) => `/school/student-school-relation/${params.id}`;

export const buildSchoolDetailPath = (params: { id: string }) => `/school/${params.id}`;

export const buildSchoolAddStaffCreatePath = (params: { id: string }) => `/school/${params.id}/add-staff/`;

export const buildSchoolAddStudentCreatePath = (params: { id: string }) => `/school/${params.id}/add-student/`;

export const buildSchoolArrangeByAmountListPath = (params: { id: string }) => `/school/${params.id}/arrange-by-amount`;

export const buildSchoolBulkInviteCreatePath = (params: { id: string }) => `/school/${params.id}/bulk-invite`;

export const buildSchoolCheckUserRelationEmailListPath = (params: { id: string }) => `/school/${params.id}/check-user-relation-email`;

export const buildSchoolCheckUserRelationNumberListPath = (params: { id: string }) => `/school/${params.id}/check-user-relation-number`;

export const buildSchoolDuplicatesCreatePath = (params: { id: string }) => `/school/${params.id}/duplicates`;

export const buildSchoolDuplicatesMarkNotDuplicatesCreatePath = (params: { id: string }) => `/school/${params.id}/duplicates/mark-not-duplicates`;

export const buildSchoolEligibleRelationsCreatePath = (params: { id: string }) => `/school/${params.id}/eligible-relations`;

export const buildSchoolInviteToAcceptListPath = (params: { id: string }) => `/school/${params.id}/invite-to-accept/`;

export const buildSchoolInviteCreatePath = (params: { id: string }) => `/school/${params.id}/invite/`;

export const buildSchoolInviteDeletePath = (params: { id: string }) => `/school/${params.id}/invite/`;

export const buildSchoolLogoListPath = (params: { id: string }) => `/school/${params.id}/logo`;

export const buildSchoolParentMiniListListPath = (params: { id: string }) => `/school/${params.id}/parent-mini-list`;

export const buildSchoolParentDetailPath = (params: { id: string; parent_id: string }) => `/school/${params.id}/parent/${params.parent_id}`;

export const buildSchoolParentsListPath = (params: { id: string }) => `/school/${params.id}/parents/`;

export const buildSchoolSettingsNotificationsListPath = (params: { id: string }) => `/school/${params.id}/settings/notifications/`;

export const buildSchoolSettingsNotificationsPartialUpdatePath = (params: { id: string }) => `/school/${params.id}/settings/notifications/`;

export const buildSchoolStaffListPath = (params: { id: string }) => `/school/${params.id}/staff`;

export const buildSchoolStaffMiniListListPath = (params: { id: string }) => `/school/${params.id}/staff-mini-list`;

export const buildSchoolStaffChartListPath = (params: { id: string }) => `/school/${params.id}/staff/chart`;

export const buildSchoolStaffDetailPath = (params: { id: string; staff_id: string }) => `/school/${params.id}/staff/${params.staff_id}`;

export const buildSchoolStudentMiniListListPath = (params: { id: string }) => `/school/${params.id}/student-mini-list`;

export const buildSchoolStudentDetailPath = (params: { id: string; student_id: string }) => `/school/${params.id}/student/${params.student_id}`;

export const buildSchoolStudentsListPath = (params: { id: string }) => `/school/${params.id}/students`;

export const buildSchoolStudentsChartListPath = (params: { id: string }) => `/school/${params.id}/students/chart`;

export const buildSchoolStudentsMergeCreatePath = (params: { id: string }) => `/school/${params.id}/students/merge`;

export const buildSchoolSuggestChangesAcceptPartialUpdatePath = (params: { id: string; change_id: string }) => `/school/${params.id}/suggest-changes/${params.change_id}/accept`;

export const buildSchoolSuggestChangesRejectPartialUpdatePath = (params: { id: string; change_id: string }) => `/school/${params.id}/suggest-changes/${params.change_id}/reject`;

export const buildSchoolUserCountListPath = (params: { id: string }) => `/school/${params.id}/user-count`;

export const buildVerifySchoolCreatePath = (params: { id: string }) => `/school/${params.id}/verify-school`;

export const buildSchoolYearsListPath = (params: { id: string }) => `/school/${params.id}/years`;

export const buildSchoolYearsPeriodGroupsPartialUpdatePath = (params: { id: string; year_id: string }) => `/school/${params.id}/years/${params.year_id}/period-groups`;

export const buildSelectListForSchoolCreatePath = (params: { school_id: string }) => `/select_list/for-school/${params.school_id}/`;

export const buildSelectListForSchoolListPath = (params: { school_id: string }) => `/select_list/for-school/${params.school_id}/`;

export const buildSelectListDetailPath = (params: { list_id: string }) => `/select_list/${params.list_id}`;

export const buildSelectListDeletePath = (params: { list_id: string }) => `/select_list/${params.list_id}`;

export const buildSelectListPartialUpdatePath = (params: { list_id: string }) => `/select_list/${params.list_id}`;

export const buildUserRolesAvailableForRelationDetailPath = (params: { relation_id: string }) => `/user-roles/available-for-relation/${params.relation_id}`;

export const buildUserRolesCheckUserRoleNameListPath = () => '/user-roles/check-user-role-name/';

export const buildUserRolesForRelationDetailPath = (params: { relation_id: string }) => `/user-roles/for-relation/${params.relation_id}`;

export const buildUserRolesForRelationPartialUpdatePath = (params: { relation_id: string }) => `/user-roles/for-relation/${params.relation_id}`;

export const buildUserRolesForSchoolCreatePath = (params: { school_id: string }) => `/user-roles/for-school/${params.school_id}`;

export const buildUserRolesForSchoolDetailPath = (params: { school_id: string }) => `/user-roles/for-school/${params.school_id}`;

export const buildUserRolesDetailPath = (params: { id: string }) => `/user-roles/${params.id}`;

export const buildUserRolesPartialUpdatePath = (params: { id: string }) => `/user-roles/${params.id}`;

export const buildUserRolesDeletePath = (params: { id: string }) => `/user-roles/${params.id}`;

export const buildUserRolesCheckSystemRoleListPath = (params: { id: string }) => `/user-roles/${params.id}/check-system-role`;

export const buildUserRolesUsersListPath = (params: { id: string }) => `/user-roles/${params.id}/users`;

export const buildUserAcceptInviteCreatePath = () => '/user/accept-invite';

export const buildUserCheckPasswordResetTokenListPath = () => '/user/check-password-reset-token';

export const buildUserCreatePasswordResetTokenCreatePath = () => '/user/create-password-reset-token';

export const buildUserCreateUnverifiedEmailCreatePath = () => '/user/create-unverified-email';

export const buildCreateUnverifiedEmailForUsernameCreatePath = () => '/user/create-unverified-email-for-username';

export const buildUserCreateUnverifiedEmailPublicCreatePath = () => '/user/create-unverified-email/public';

export const buildUserDbConsistencyCheckListPath = () => '/user/db_consistency_check';

export const buildUserEmailInUseForSchoolCreatePath = (params: { school_id: string }) => `/user/email-in-use/for-school/${params.school_id}`;

export const buildUserEmailInUsePublicCreatePath = () => '/user/email-in-use/public';

export const buildUserFiltersListPath = () => '/user/filters';

export const buildUserFiltersCreatePath = () => '/user/filters';

export const buildUserFiltersList2Path = (params: { filter_id: string }) => `/user/filters/${params.filter_id}/`;

export const buildUserFiltersPartialUpdatePath = (params: { filter_id: string }) => `/user/filters/${params.filter_id}/`;

export const buildUserFiltersDeletePath = (params: { filter_id: string }) => `/user/filters/${params.filter_id}/`;

export const buildUserHealthcheckListPath = () => '/user/healthcheck';

export const buildUserMergeChildrenCreatePath = () => '/user/merge/children';

export const buildUserNotificationsListPath = () => '/user/notifications';

export const buildUserNotificationsDeletePath = (params: { notification_id: string }) => `/user/notifications/${params.notification_id}`;

export const buildUserNotificationsReadPartialUpdatePath = (params: { notification_id: string }) => `/user/notifications/${params.notification_id}/read`;

export const buildUserParentCreatePath = () => '/user/parent';

export const buildUserPushTokenCreatePath = () => '/user/push_token';

export const buildUserPushTokenPartialUpdatePath = () => '/user/push_token';

export const buildUserPushTokenDeletePath = () => '/user/push_token';

export const buildUserSetContactEmailCreatePath = () => '/user/set-contact-email';

export const buildUserSyncCreatePath = () => '/user/sync';

export const buildUpdateUserPasswordPartialUpdatePath = () => '/user/update-user-password';

export const buildUserVerifyContactEmailCreatePath = () => '/user/verify-contact-email';

export const buildUserVerifyEmailCreatePath = () => '/user/verify-email';

export const buildVerifyEmailForUsernameCreatePath = () => '/user/verify-email-for-username';

export const buildUserVerifyEmailSignupCreatePath = () => '/user/verify-email-signup';

export const buildUserListPath = (params: { id: string }) => `/user/${params.id}/`;

export const buildUserPartialUpdatePath = (params: { id: string }) => `/user/${params.id}/`;

export const buildUserDeletePath = (params: { id: string }) => `/user/${params.id}/`;

export const buildUserAccountDeletePath = (params: { id: string }) => `/user/${params.id}/account`;

export const buildUserAvatarListPath = (params: { id: string }) => `/user/${params.id}/avatar`;
